import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row, Col, BreadcrumbItem } from 'reactstrap';
import './breadcrumb.scss';

const HEADER_SLOT_ID = 'page-header-breadcrumb';

/**
 * Page title + breadcrumb. Renders into the top bar (next to the menu toggler)
 * when the layout header provides the `#page-header-breadcrumb` slot, so the
 * page body starts right at the content. Falls back to the classic in-page
 * title box when no slot exists (auth layouts etc.).
 */
const Breadcrumb = ({ title, breadcrumbItem }) => {
  const [slot, setSlot] = useState(null);

  useEffect(() => {
    setSlot(document.getElementById(HEADER_SLOT_ID));
  }, []);

  useEffect(() => {
    if (breadcrumbItem) document.title = `${breadcrumbItem} | SHOFCO - SUN Portal`;
  }, [breadcrumbItem]);

  if (slot) {
    return createPortal(
      <div className="page-header-title min-w-0">
        <h4 className="mb-0 font-size-16 text-truncate">{breadcrumbItem}</h4>
        <ol className="breadcrumb m-0 d-none d-md-flex font-size-12">
          <BreadcrumbItem>
            <Link to="#">{title}</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>{breadcrumbItem}</BreadcrumbItem>
        </ol>
      </div>,
      slot,
    );
  }

  return (
    <Row>
      <Col className="col-12">
        <div className="page-title-box d-sm-flex-col align-items-center justify-content-between">
          <h4 className="mb-sm-0 font-size-18">{breadcrumbItem}</h4>
          <div className="page-title-right mt-3">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <Link to="#">{title}</Link>
              </BreadcrumbItem>
              <BreadcrumbItem active>
                <Link to="#">{breadcrumbItem}</Link>
              </BreadcrumbItem>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  );
};

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
};

export default Breadcrumb;
